import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Tractor, Shield, DollarSign, Users, GraduationCap, Heart } from "lucide-react";

const issues = [
  {
    icon: GraduationCap,
    title: "Education Reform",
    description: "Fighting for perspective-neutral classrooms, local control, and returning decision-making power to school boards.",
  },
  {
    icon: Shield,
    title: "Second Amendment",
    description: "Defending constitutional gun rights against incremental restrictions that target law-abiding citizens.",
  },
  {
    icon: DollarSign,
    title: "Stop Unfunded Mandates",
    description: "Opposing legislative mandates that burden local districts without providing necessary funding.",
  },
  {
    icon: Users,
    title: "Student Safety",
    description: "Supporting alternative schools and discipline reforms to maintain safety in mainstream classrooms.",
  },
  {
    icon: Heart,
    title: "Election Integrity",
    description: "Supporting voter ID laws and opposing the nationalization of elections to ensure secure voting.",
  },
  {
    icon: Tractor,
    title: "Rural Representation",
    description: "Speaking the values of the 33rd District clearly in Dover and fighting for rural interests.",
  },
];

const IssuesPreview = () => {
  return (
    <section className="py-20 bg-card" aria-labelledby="issues-preview-heading">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 id="issues-preview-heading" className="font-display text-4xl md:text-5xl font-bold text-foreground mb-4">
            Fighting for What Matters
          </h2>
          <p className="font-body text-lg text-muted-foreground max-w-2xl mx-auto">
            Matt Bucher is committed to conservative principles that protect our rural way of life and strengthen our communities.
          </p>
        </div>

        <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" role="list">
          {issues.map((issue, index) => (
            <li
              key={issue.title}
              className="bg-background p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow border border-border group"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="w-14 h-14 bg-primary/10 rounded-full flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors" aria-hidden="true">
                <issue.icon className="h-7 w-7 text-primary" aria-hidden="true" />
              </div>
              <h3 className="font-display text-xl font-bold text-foreground mb-2">
                {issue.title}
              </h3>
              <p className="font-body text-muted-foreground">
                {issue.description}
              </p>
            </li>
          ))}
        </ul>

        <div className="text-center mt-12">
          <Button variant="navy" size="lg" asChild>
            <Link to="/issues">Read Full Platform</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default IssuesPreview;
